/* global femcare */

femcare.shared.customDropdown = {

  create: function (container) {

    var hiddenDropdownElement = container.getElementsByTagName('select')[0];
    var optionCount = hiddenDropdownElement.length;

    // Create the custom dropdown markup based on the hidden select
    var customDropdownElement = document.createElement('div');
    customDropdownElement.setAttribute('class', 'select-selected');
    customDropdownElement.innerHTML = hiddenDropdownElement.options[hiddenDropdownElement.selectedIndex].innerHTML;
    container.appendChild(customDropdownElement);

    var customOptionList = document.createElement('div');
    customOptionList.setAttribute('class', 'select-items select-hide');

    for (var optionIndex = 1; optionIndex < optionCount; optionIndex++) {
      var customOption = document.createElement('div');
      customOption.innerHTML = hiddenDropdownElement.options[optionIndex].innerHTML;
      customOption.setAttribute('data-value', hiddenDropdownElement.options[optionIndex].getAttribute('value'));
      customOption.addEventListener('click', function (e) {
        femcare.shared.customDropdown.setOption(e.currentTarget);
      });
      customOptionList.appendChild(customOption);
    }

    container.appendChild(customOptionList);

    var icon = document.createElement('i');
    icon.classList.add('select-toggle', 'icon-arrow-down-smooth');
    container.append(icon);

    // Close other custom dropdowns
    customDropdownElement.addEventListener('click', function (e) {
      e.stopPropagation();
      closeOtherSelectDropdowns(this);
      this.parentNode.getElementsByClassName('select-items')[0].classList.toggle('select-hide');
      icon.classList.toggle('icon-arrow-down-smooth');
      icon.classList.toggle('icon-arrow-up-smooth');
    });

    function closeOtherSelectDropdowns(customSelect) {
      /* Close all dropdown boxes in the document except the current one */
      var arrNo = [];
      var allCustomOptionLists = document.getElementsByClassName('select-items');
      var allCustomSelects = document.getElementsByClassName('select-selected');
      var totalCustomOptionListCount = allCustomOptionLists.length;
      var totalCustomSelectCount = allCustomSelects.length;

      for (var i = 0; i < totalCustomSelectCount; i++) {
        if (customSelect === allCustomSelects[i]) {
          arrNo.push(i);
        } else {
          var icon = allCustomSelects[i].parentNode.getElementsByClassName('select-toggle')[0];
          icon.classList.remove('icon-arrow-up-smooth');
          icon.classList.add('icon-arrow-down-smooth');
        }
      }
      for (var j = 0; j < totalCustomOptionListCount; j++) {
        if (arrNo.indexOf(j)) {
          allCustomOptionLists[j].classList.add('select-hide');
        }
      }
    }

    /* If the user clicks anywhere outside the dropdown box,
    then close all dropdown boxes: */
    document.addEventListener('click', closeOtherSelectDropdowns);
  },

  setOption: function (option) {
    /* When an item is clicked, update the original dropdown box,
    and the selected item: */
    var selectElement = option.parentNode.parentNode.getElementsByTagName('select')[0];
    var optionsCount = selectElement.length;
    var customSelect = option.parentNode.previousSibling;
    for (var i = 0; i < optionsCount; i++) {
      if (selectElement.options[i].innerHTML === option.innerHTML) {
        selectElement.selectedIndex = i;
        customSelect.innerHTML = option.innerHTML;
        var selectedOptions = option.parentNode.getElementsByClassName('same-as-selected');
        var selectedOptionsCount = selectedOptions.length;
        for (var j = 0; j < selectedOptionsCount; j++) {
          selectedOptions[j].removeAttribute('class');
        }
        option.setAttribute('class', 'same-as-selected');
        break;
      }
    }
    customSelect.click();
  }
};